import React from 'react';
import { useTheme } from '@material-ui/core/styles';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';
import Container from 'common/Container';
import Grid from '@material-ui/core/Grid';
import Card from '@material-ui/core/Card';
import CardActionArea from '@material-ui/core/CardActionArea';
import CardContent from '@material-ui/core/CardContent';
import { Link as RouterLink } from 'react-router-dom';
import ArrowForwardIcon from '@material-ui/icons/ArrowForward';
import {
  WIKI_MANUAL_OPERADOR_AUDIOVISUAL_PATH,
  WIKI_MANUAL_PAUTAS_EXTERIORES_PATH,
  WIKI_MANUAL_SUBIDA_PROGRAMAS_PATH,
  WIKI_MANUAL_PUBLICAR_NOTICIAS_TNO_PATH,
} from 'constants/wikiRoutes';

const MANUALS = [
  {
    key: 'operador-audiovisual',
    title: 'Manual del operador audiovisual',
    description:
      'Rol en cabina, permanencia y ausencias, confidencialidad, ponche y salida al aire, post-producción y subida, vMix/OBS y estándares TNO. Contenido actualizado desde Academy.',
    to: WIKI_MANUAL_OPERADOR_AUDIOVISUAL_PATH,
  },
  {
    key: 'pautas-exteriores',
    title: 'Pautas en exteriores y locaciones no cabina',
    description:
      'Café, oficina u otro espacio: laptop con el mismo sistema, red móvil y WiFi, energía, acústica, permisos del local, contingencia y checklist de maleta. Desde Academy.',
    to: WIKI_MANUAL_PAUTAS_EXTERIORES_PATH,
  },
  {
    key: 'subida-programas',
    title: 'Manual de subida de programas',
    description:
      'YouTube y otras plataformas, verificación, alta en Sistema TNO (sistema.tnonetwork.com), limpieza de cabina y checklist. Una sola guía completa.',
    to: WIKI_MANUAL_SUBIDA_PROGRAMAS_PATH,
  },
  {
    key: 'publicar-noticias-tno',
    title: 'Ghost → Canva → Instagram',
    description:
      'Ciclo de publicación: artículo en Ghost (TNO Digest), reel en Canva y difusión en Instagram (feed e historias con link).',
    to: WIKI_MANUAL_PUBLICAR_NOTICIAS_TNO_PATH,
  },
];

const LandingWikiHome = () => {
  const theme = useTheme();

  return (
    <Box>
      <Box
        minHeight={{ xs: 'auto', md: 280 }}
        display="flex"
        alignItems="center"
        justifyContent="center"
        sx={{
          backgroundImage: 'linear-gradient(135deg, rgba(0,0,0,0.85) 0%, rgba(40,40,40,0.9) 100%)',
          position: 'relative',
          '&:after': {
            content: '" "',
            position: 'absolute',
            inset: 0,
            zIndex: 1,
            backgroundColor: theme.palette.primary.dark,
            opacity: 0.72,
          },
        }}
      >
        <Box position="relative" zIndex={2} width="100%" py={{ xs: 5, md: 7 }}>
          <Container>
            <Box textAlign="center" color="common.white">
              <Typography variant="overline" sx={{ fontWeight: 600, letterSpacing: 1 }}>
                TNO Network
              </Typography>
              <Typography variant="h3" component="h1" fontWeight={900} gutterBottom>
                Wiki y manuales internos
              </Typography>
              <Typography variant="body1" sx={{ maxWidth: 560, mx: 'auto', opacity: 0.92 }}>
                Documentación operativa para el equipo. Elige un manual; el texto se carga desde el servicio Academy.
              </Typography>
            </Box>
          </Container>
        </Box>
      </Box>

      <Container sx={{ py: { xs: 4, md: 6 } }}>
        <Typography variant="h5" fontWeight={700} gutterBottom>
          Manuales disponibles
        </Typography>
        <Typography variant="body2" color="textSecondary" paragraph sx={{ maxWidth: 720 }}>
          Aquí iremos publicando nuevos manuales. Si no ves contenido, revisa que el API de Academy esté configurado y
          que existan páginas publicadas en la categoría correspondiente.
        </Typography>

        <Grid container spacing={3}>
          {MANUALS.map((item) => (
            <Grid item xs={12} sm={6} md={4} key={item.key}>
              <Card variant="outlined" sx={{ height: '100%', borderRadius: 2 }}>
                <CardActionArea component={RouterLink} to={item.to} sx={{ height: '100%', alignItems: 'stretch' }}>
                  <CardContent sx={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
                    <Typography variant="h6" fontWeight={700} gutterBottom>
                      {item.title}
                    </Typography>
                    <Typography variant="body2" color="textSecondary" sx={{ flexGrow: 1, mb: 2 }}>
                      {item.description}
                    </Typography>
                    <Box display="flex" alignItems="center" color="primary.main" fontWeight={600}>
                      Abrir manual
                      <ArrowForwardIcon sx={{ ml: 0.5, fontSize: 20 }} />
                    </Box>
                  </CardContent>
                </CardActionArea>
              </Card>
            </Grid>
          ))}
        </Grid>
      </Container>
    </Box>
  );
};

export default LandingWikiHome;
